module.exports = new __parcel__URL__("tripperstories.02c9a680.png").toString();